import { PATTERNS_VALIDATIONS } from "../utils/validationsForFields";

function formFosfecAdapter(data: any) {
return {
  modalBlockActaullyWorking: {
    title: data.modalBlockActaullyWorking.nodes[0].tituloPrincipal, 
    description: JSON.parse(data.modalBlockActaullyWorking.nodes[0].descripcionFormulario?.raw).content.map((item: any, itemIdx: number) => {  
      return item.content[0].value + '\n';
    }),
    icon: data.modalBlockActaullyWorking.nodes[0].imagenFormulario?.file.url,
    primaryButton: {
      title: data.modalBlockActaullyWorking.nodes[0].tituloBoton, 
      url: data.modalBlockActaullyWorking.nodes[0].redireccionBoton ,
    },
    secundaryButton: {
      title: data.modalBlockActaullyWorking.nodes[0].tituloBotonOpcional, 
      url: data.modalBlockActaullyWorking.nodes[0].redireccionBotonOpcional,
    },
  },
  modalBlockRecivedPension: {
    title: data.modalBlockRecivedPension.nodes[0].tituloPrincipal, 
    description: JSON.parse(data.modalBlockRecivedPension.nodes[0].descripcionFormulario?.raw).content.map((item: any, itemIdx: number) => {  
      return item.content[0].value + '\n';
    }),
    icon: data.modalBlockRecivedPension.nodes[0].imagenFormulario?.file.url,
    primaryButton: {
      title: data.modalBlockRecivedPension.nodes[0].tituloBoton, 
      url: data.modalBlockRecivedPension.nodes[0].redireccionBoton ,
    },
    secundaryButton: {
      title: data.modalBlockRecivedPension.nodes[0].tituloBotonOpcional, 
      url: data.modalBlockRecivedPension.nodes[0].redireccionBotonOpcional,
    },
  },
  modalBlockDifferentCompensationFund : {
    title: data.modalBlockDifferentCompensationFund.nodes[0].tituloPrincipal, 
    description: JSON.parse(data.modalBlockDifferentCompensationFund.nodes[0].descripcionFormulario?.raw).content.map((item: any, itemIdx: number) => {  
      return item.content[0].value + '\n';
    }),
    icon: data.modalBlockDifferentCompensationFund.nodes[0].imagenFormulario?.file.url,
    primaryButton: {
      title: data.modalBlockDifferentCompensationFund.nodes[0].tituloBoton, 
      url: data.modalBlockDifferentCompensationFund.nodes[0].redireccionBoton ,
    },
    secundaryButton: {
      title: data.modalBlockDifferentCompensationFund.nodes[0].tituloBotonOpcional, 
      url: data.modalBlockDifferentCompensationFund.nodes[0].redireccionBotonOpcional,
    },
  },
  modalBlockedNotRegisteredSISE : {
    title: data.modalBlockedNotRegisteredSISE.nodes[0].tituloPrincipal, 
    description: JSON.parse(data.modalBlockedNotRegisteredSISE.nodes[0].descripcionFormulario?.raw).content.map((item: any, itemIdx: number) => {  
      return item.content[0].value + '\n';
    }),
    icon: data.modalBlockedNotRegisteredSISE.nodes[0].imagenFormulario?.file.url,
    primaryButton: {
      title: data.modalBlockedNotRegisteredSISE.nodes[0].tituloBoton, 
      url: data.modalBlockedNotRegisteredSISE.nodes[0].redireccionBoton ,
    },
    secundaryButton: {
      title: data.modalBlockedNotRegisteredSISE.nodes[0].tituloBotonOpcional, 
      url: data.modalBlockedNotRegisteredSISE.nodes[0].redireccionBotonOpcional,
    },
  },
  modalConfirmationMessage : {
    title: data.modalConfirmationMessage.nodes[0].tituloPrincipal, 
    description: JSON.parse(data.modalConfirmationMessage.nodes[0].descripcionFormulario?.raw).content.map((item: any, itemIdx: number) => {  
      return item.content[0].value + '\n';
    }),
    icon: data.modalConfirmationMessage.nodes[0].imagenFormulario?.file.url,
    primaryButton: {
      title: data.modalConfirmationMessage.nodes[0].tituloBoton, 
      url: data.modalConfirmationMessage.nodes[0].redireccionBoton ,
    },
    secundaryButton: {
      title: data.modalConfirmationMessage.nodes[0].tituloBotonOpcional, 
      url: data.modalConfirmationMessage.nodes[0].redireccionBotonOpcional,
    },
  },
  modalEmploymentPath: {
    title: data.modalEmploymentPath.nodes[0].tituloPrincipal,
    description: JSON.parse(data.modalEmploymentPath.nodes[0].descripcionFormulario?.raw).content.map((item: any, itemIdx: number) => {
      return item.content[0].value + '\n';
    }),
    icon: data.modalEmploymentPath.nodes[0].imagenFormulario?.file.url,
    primaryButton: {
      title: data.modalEmploymentPath.nodes[0].tituloBoton,
      url: data.modalEmploymentPath.nodes[0].redireccionBoton ,
    },
    secundaryButton: {
      title: data.modalEmploymentPath.nodes[0].tituloBotonOpcional,
      url: data.modalEmploymentPath.nodes[0].redireccionBotonOpcional,
    },
  },
  backgroundImageDesktop: data.form.nodes[0].imagenFormulario.file.url,
  mainTitle: data.form.nodes[0].tituloFormulario,
  mainDescription : JSON.parse(data.form.nodes[0].descripcionFormulario.raw).content[0].content[0].value,
  sections :  data.form.nodes[0].titulosFormulario?.map((step: any, stepIdx: number) => {
    return {
      id: stepIdx,
      title: step.tituloGeneral,
      idContentful: step.contentful_id,
      description: JSON.parse(step.descripcion.raw).content,
      imagenes: step.listaImagenes?.map((image: any, imageIdx: number) => ({
        key: imageIdx,
        urlImage: image.url,
        title: image.title,
        description: image.description,
        idContentful: image.contentful_id
      })),
      fields: step.referenciaFormulario?.map((field: any, fieldIdx: number) => {
        return {
          id: fieldIdx,
          name: field.nombreId,
          type: field.tipoCampo,
          label: field.inputPrincipal,
          required: field.obligatorio,
          hidden: field.nombreId === "pensionFundAfiliate" || field.nombreId === "noPensionPayed" ? true : false,
          disabled: field.deshabilitado,
          validations: PATTERNS_VALIDATIONS[field.nombreId],
          helperText: field.textoTerminos && JSON.parse(field.textoTerminos?.raw).content[0].content[0].value,
          helperTextUriText: field.textoTerminos && JSON.parse(field.textoTerminos?.raw).content[0].content[1]?.content[0].value,
          helperTextUri: field.textoTerminos && JSON.parse(field.textoTerminos?.raw).content[0].content[1]?.data?.uri,
          help: "Ayuda campo",
          acceptedFileTypes: ".pdf, .jpeg, .png",
          options: field.listaSelect?.map((option: any, optionIdx: number) => ({
            id: optionIdx,
            label: option,
            value: option
          }))
        };
      }),       
    };
  }),
}
}

export default formFosfecAdapter;
